export const notif = (isCheck = false, notif) => {
  if (!isCheck) {
    let elem = document.querySelector(".notification-alert");
    elem.innerHTML = notif;
    elem.classList.add("slideInUp-short");
    elem.classList.add("animated-long");

    setTimeout(function() {
      let elem = document.querySelector(".notification-alert");
      elem.classList.remove("slideInUp-short");
      elem.classList.remove("animated-long");
    }, 2500);
    return false;
  }
  return true;
};
